import React, {useCallback, useState} from "react";
import "./DeliveryProviderForm/upload-delivery-provider-form.css";
import {EditDeliveryProvider} from "./UpdateDeliveryProvider.jsx";
import {CreateDeliveryProvider} from "./CreateDeliveryProvider.jsx";
import {SuccessImageLink} from "../../upload/consts.jsx";
import {GenericModal} from "../../../components/index.jsx";

export const UpsertDeliveryProvider = ({deliveryProvider, history, fetchDeliveryProvider, isLoading}) => {
    const [savedDeliveryProviderSuccessfully, setSavedDeliveryProviderSuccessfully] = useState(false);

    const onUpdateSuccess = useCallback(() => {
        setSavedDeliveryProviderSuccessfully(true);
        fetchDeliveryProvider();
    }, [fetchDeliveryProvider]);

    return (
        <div className="upsert-delivery-provider">
            <GenericModal
                visible={savedDeliveryProviderSuccessfully}
                image={SuccessImageLink}
                onClose={() => setSavedDeliveryProviderSuccessfully(false)}
                className={"order-location-input-upload-excel-modal"}
                title="נשמר בהצלחה!"
                options={[
                    {
                        id: "save",
                        text: "מגניבבב",
                        onClick: () => setSavedDeliveryProviderSuccessfully(false)
                    }
                ]}
            />

            {deliveryProvider?.deliveryProviderId ? (
                <EditDeliveryProvider
                    deliveryProvider={deliveryProvider}
                    isLoading={isLoading}
                    onSuccess={onUpdateSuccess}
                />
            ) : (
                <CreateDeliveryProvider
                    history={history}
                    onSuccess={() => setSavedDeliveryProviderSuccessfully(true)}
                />
            )}
        </div>
    );
};
